export default __webpack_public_path__ + "static/media/value-indicator-shape.fe4a2d26.svg";